/* eslint-disable */
import { GetterTree } from "vuex";
import { OfferStatus } from "@/models/offerStatus";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { OfferStatusState } from "@/types/offerStatus";

const getters: GetterTree<OfferStatusState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new OfferStatus();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((offerStatus) =>
          OfferStatus.toSelectItem(offerStatus)
        )
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((offerStatus) => {
          return offerStatus.id == id;
        })
      : new OfferStatus();
  },
};

export default getters;
